var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ya-site-resource-list',{attrs:{"resource":"hotel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }